import { shallowReactive } from 'vue';
import axios from 'axios';
const MAX_ENTRIES = 500;
const SECRET_KEY = /password|^pass$|^pin$|token/i;
// Raw values, formatted only when shown, so logging costs nothing for members who never open the page
export const debugEntries = shallowReactive([]);
function add(entry) {
    debugEntries.push(entry);
    if (debugEntries.length > MAX_ENTRIES)
        debugEntries.shift();
}
// Headers are never recorded (they carry the bearer token); secret-looking keys in bodies are masked
export function format(value) {
    if (value === undefined)
        return '';
    if (typeof value === 'string') {
        try {
            value = JSON.parse(value);
        }
        catch {
            return value;
        }
    }
    if (value instanceof Error)
        return value.stack || value.message;
    try {
        return JSON.stringify(value, (key, v) => (SECRET_KEY.test(key) ? '•••' : v), 2);
    }
    catch {
        return String(value);
    }
}
export function clearDebugLog() {
    debugEntries.splice(0);
}
export function installDebugLog() {
    for (const level of ['log', 'info', 'warn', 'error']) {
        const original = console[level].bind(console);
        console[level] = (...args) => {
            original(...args);
            add({ kind: 'console', time: new Date(), level, args });
        };
    }
    window.addEventListener('error', (e) => {
        add({ kind: 'console', time: new Date(), level: 'error', args: [e.error || e.message] });
    });
    window.addEventListener('unhandledrejection', (e) => {
        add({ kind: 'console', time: new Date(), level: 'error', args: ['Unhandled rejection:', e.reason] });
    });
    axios.interceptors.request.use((config) => {
        config.debugStart = Date.now();
        return config;
    });
    const record = (config, status, data) => {
        add({
            kind: 'network',
            time: new Date(),
            method: (config?.method || '').toUpperCase(),
            url: config?.url || '',
            status,
            ms: config?.debugStart ? Date.now() - config.debugStart : 0,
            request: config?.data,
            response: data
        });
    };
    axios.interceptors.response.use((response) => {
        record(response.config, response.status, response.data);
        return response;
    }, (error) => {
        record(error.config, error.response?.status ?? 'failed', error.response?.data ?? error.message);
        return Promise.reject(error);
    });
}
